<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="sup-footer">
            <div class="container">
                <div class="col-left">
                    <div class="footer-social">
                        <h3>
                            <span v-if="lang == 'kz/'">Біз Сізбен барлық уақытта байланыстамыз</span>
                            <span v-else>Мы всегда на связи с Вами</span>
                        </h3>
                        <div class="social-items">
                            <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                                <svg-icon icon-class="instagram" className="icon-soc icon-instagram"/>
                            </a>
                            <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                                <svg-icon icon-class="facebook" className="icon-soc icon-facebook"/>
                            </a>
                            <a :href="setup.footer_social_links.vk" class="social-item" target="_blank">
                                <svg-icon icon-class="vk" className="icon-soc icon-vk"/>
                            </a>
                            <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                                <svg-icon icon-class="telegram" className="icon-soc icon-telegram"/>
                            </a>
                        </div>
                    </div>
                    <div class="follow-email">
                        <h3>
                            <span v-if="lang == 'kz/'">Жаңаықтар мен акцияларға жазылыңыз:</span>
                            <span v-else>Подписывайтесь на новости и акции:</span>
                        </h3>
                        <formFooterMail></formFooterMail>
                        <p class="anounce-msg">
                            <span v-if="lang == 'kz/'">Бірінші болыңыз және компанияның барлық соңғы жаңалықтарынан хабардар болыңыз, сондай-ақ, арнайы акциялық ұсыныстардан көз жазбаңыз.</span>
                            <span v-else>Будьте первыми и узнавайте все самые
                            последние новости компании, а также
                            следите за специальными акционными
                            предложениями.</span>
                        </p>
                    </div>
                </div>
                <div class="col-center">
                    <div class="footer-contacts" v-if="!reverse">
                        <div class="item" v-for="item in setup.footer_contacts">
                            <div class="adres">
                                <div class="top">
                                    <svg-icon icon-class="pin" className="icon-pin"/>
                                    {{item.region}}
                                </div>
                                <p>{{item.adres}}</p>
                            </div>
                            <div class="phone">
                                <svg-icon icon-class="mobile" className="icon-mobile"/>
                                <a :href="'tel:' + item.phone">{{item.phone}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="footer-contacts" v-else>
                        <div class="item" v-for="item in setup.footer_contacts.slice().reverse()">
                            <div class="adres">
                                <div class="top">
                                    <svg-icon icon-class="pin" className="icon-pin"/>
                                    {{item.region}}
                                </div>
                                <p>{{item.adres}}</p>
                            </div>
                            <div class="phone">
                                <svg-icon icon-class="mobile" className="icon-mobile"/>
                                <a :href="'tel:' + item.phone">{{item.phone}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="navigation-footer">
                        <div class="left">
                            <ul>
                                <li v-for="item in setup.main_page_navigation_footer">
                                    <router-link :to="item.href">{{item.name}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer-awards">
                        <div class="awards">
                            <div class="award-item" v-for="item in setup.footer_awards.awards">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                        <div class="certifications">
                            <div class="cert-item" v-for="item in setup.footer_awards.sertificats">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-footer">
            <div class="container">
                <div class="copy">
                    <p>{{setup.copyright}}</p>
                </div>
                <div class="footer-links">
                    <ul>
                        <li><router-link :to="'/' + setup.politics.link">{{setup.politics.name}}</router-link></li>
                        <!-- <li><router-link :to="setup.error.link">{{setup.error.name}}</router-link></li> -->
                    </ul>
                </div>
                <div class="made-in">
                    <p>Developed by</p>
                    <a href="https://v-web.kz" target="_blank">Victory WEB</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import formFooterMail from '@/components/forms/form-footer-mail.vue'
    export default {
        name: 'AppFooter',
        data () {
            return {
                reverse: false,
                lang: window.GlobalLang,
            }
        },
        components: {
            formFooterMail,
        },
        methods: {
            checkCity() {
                // console.log(this.currentCity, 'city cur');
                if (this.currentCity[0].region_lat.slug == 'nur-sultan') {
                    this.reverse = true
                } else {
                    this.reverse = false
                }
            },
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
            currentCity() {
                return this.$store.state.currentCityArr
            }
        },
        created() {
        },
        mounted() {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        this.checkCity();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
    @import '@/styles/respond/footer/respond-footer.scss';
</style>